<template>
  <v-app>
    <!-- Header -->
    <PropertyManagerScreenHeader v-if="hasTitle" />
    <v-main>
      <v-container fluid class="d-flex flex-column min-height container">
        <!-- Navbar -->
        <PropertyManagerNavbar :temporary v-model="navbarStore.showNavbar" v-if="hasMenu" />
        <div class="content" :style="hasTitle ? 'min-height: 95vh;' : 'min-height: 100vh;'">
          <TitlePage :title="$t(titleKey)" :hasFavourite v-if="hasTitle" />
          <div class="page-section flex-grow-1">
            <NuxtPage />
          </div>
          <PropertyManagerScreenFooter />
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import TitlePage from '@/components/property-manager/title-page.vue';
import { titleMap } from '~/constants/title-map';
import { useWindowSize } from '@vueuse/core';

const { width, height } = useWindowSize();
const navbarStore = useNavbarStore();
const temporary = ref(false);
const route = useRoute();
const titleKey = ref('');
const hasFavourite = ref(true);
const noFavouriteList = ['prop-002', 'prop-005', 'prop-013', 'prop-019', 'prop-022', 'prop-023-02', 'prop-024', 'prop-025'];
const hasTitle = ref(true);
watch(
  route,
  (to) => {
    if (width.value < 1200) {
      navbarStore.showNavbar = false;
    } else {
      navbarStore.showNavbar = !(to.path.includes('prop-002') || to.path === '/');
    }
    const propMatch = to.path.match(/\/property-manager\/([^/]+)\/?$/);
    const key = propMatch?.[1] ?? '';
    titleKey.value = titleMap[key] || '';

    for (const e of noFavouriteList) {
      if (to.path.includes(e)) {
        hasFavourite.value = false;
        break;
      } else {
        hasFavourite.value = true;
      }
    }
    hasTitle.value = !to.path.includes('login') && to.path != '/';
  },
  { immediate: true }
);
const hasMenu = computed(() => {
  if (route.path.includes('/prop-001')) {
    return false;
  }
  return !route.path.includes('/property-manager/prop-002') && route.path != '/';
});

const handleBlur = (e: any) => {
  if (e.target instanceof Element && e.target.matches('input, textarea')) {
    window.scrollTo(0, 1);
    (document.querySelector('.content') as HTMLElement).style.paddingTop = "16px";
  }
};

onMounted(async () => {
  await nextTick();
  handleResize();
  window.addEventListener('resize', handleResize);
  window.addEventListener('blur', function (e) {
    handleBlur(e)
  }, true);
});

const handleResize = () => {
  if (window.innerWidth < 1024) {
    if (navbarStore.showNavbar) {
      navbarStore.showNavbar = false;
    }
    temporary.value = true;
  } else {
    temporary.value = false;
  }
};

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('blur', function (e) {
    handleBlur(e)
  });
});
</script>
<style scoped>
.container {
  height: 0px;
  padding: 0px;
}
.content {
  overflow: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
}
</style>
